import { format } from "date-fns";
import { type AutomatedInviteDefault as AutomatedInviteDefaultResponse } from "../api";
import { Utility } from "./utility";

export interface AutomatedInviteDefault extends AutomatedInviteDefaultResponse {}

export class AutomatedInviteDefault extends Utility<AutomatedInviteDefault> {
  constructor(init?: Partial<AutomatedInviteDefault>) {
    super();
    Object.assign(this, init);
  }

  get local_updated_at_time(): Date | null {
    if (this.updated_at === undefined) return null;
    return this.get_local_time(this.updated_at);
  }

  get local_updated_at_time_string(): string | null {
    if (this.local_updated_at_time === null) return null;
    return format(this.local_updated_at_time, "MMM d, HH:mm");
  }
}
